<template>
  <div class="home">
    <LoaderComponent v-show="loading" />
    <HeaderView />
    <section
      class="dashboard-page-main-sec agency-design-grid-right affiliate-overview-page"
    >
      <div class="affiliate-page-header">
        <div class="affiliate-page-header__copy">
          <h2 class="affiliate-page-header__title">Affiliate</h2>
          <p class="affiliate-page-header__sub">
            {{ activeLinksCount }} active links &amp; codes · all-time figures
          </p>
        </div>
        <button type="button" class="affiliate-new-btn" @click="newReferralOpen = true">
          + New referral
        </button>
      </div>

      <div class="affiliate-tabs">
        <button
          type="button"
          :class="{ active: activeTab === 'overview' }"
          @click="setTab('overview')"
        >
          Overview
        </button>
        <button
          type="button"
          :class="{ active: activeTab === 'links' }"
          @click="setTab('links')"
        >
          Links &amp; codes <span class="affiliate-tab-count">{{ url_lists.length }}</span>
        </button>
        <button
          type="button"
          :class="{ active: activeTab === 'activity' }"
          @click="setTab('activity')"
        >
          Activity <span class="affiliate-tab-count">{{ activityTabCount }}</span>
        </button>
        <button
          type="button"
          :class="{ active: activeTab === 'payouts' }"
          @click="setTab('payouts')"
        >
          Payouts <span class="affiliate-tab-count">{{ historyPayouts.length }}</span>
        </button>
      </div>

      <div v-show="activeTab === 'overview'" class="affiliate-tab-panel">
        <UserStatesView
          :affiliateStatsData="affiliateStatsData"
          :earningLists="earning_lists"
          :payouts="historyPayouts"
          :loading="statsLoading"
        />
        <EarningHistoryView
          :earning_lists="earning_lists"
          :preview="true"
          @view-all="setTab('activity')"
        />
        <AffiliateUrlsList
          :url_lists="url_lists"
          :earning_lists="earning_lists"
          :preview="true"
          @view-all="setTab('links')"
          @updated="onReferralUpdated"
        />
        <PayoutHistoryView
          ref="overviewPayouts"
          :earning_lists="earning_lists"
          :historyPayouts="historyPayouts"
          :affiliateStatsData="affiliateStatsData"
          :showPayoutBtn="showPayoutBtn"
          :preview="true"
          @view-all="setTab('payouts')"
          @submit-withdraw="submitWithdraw"
        />
      </div>

      <div v-show="activeTab === 'links'" class="affiliate-tab-panel">
        <AffiliateUrlsList
          :url_lists="url_lists"
          :earning_lists="earning_lists"
          @updated="onReferralUpdated"
        />
      </div>

      <div v-show="activeTab === 'activity'" class="affiliate-tab-panel">
        <EarningHistoryView :earning_lists="earning_lists" />
      </div>

      <div v-show="activeTab === 'payouts'" class="affiliate-tab-panel">
        <PayoutHistoryView
          ref="tabPayouts"
          :earning_lists="earning_lists"
          :historyPayouts="historyPayouts"
          :affiliateStatsData="affiliateStatsData"
          :showPayoutBtn="showPayoutBtn"
          @submit-withdraw="submitWithdraw"
        />
      </div>

      <NewReferralModal
        v-if="newReferralOpen"
        @close="newReferralOpen = false"
        @created="onReferralCreated"
      />
    </section>
  </div>
</template>

<script>
import HeaderView from "@/components/layout/HeaderComponent.vue";
import UserStatesView from "@/components/affiliateComponents/UserStates.vue";
import EarningHistoryView from "@/components/affiliateComponents/EarningHistory.vue";
import PayoutHistoryView from "@/components/affiliateComponents/PayoutHistory.vue";
import AffiliateUrlsList from "@/components/affiliateComponents/AffiliateUrlList.vue";
import NewReferralModal from "@/components/affiliateComponents/NewReferralModal.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import { useToast } from "vue-toastification";
const toast = useToast();

const AFFILIATE_TABS = ["overview", "links", "activity", "payouts"];

export default {
  name: "DashboardView",
  components: {
    HeaderView,
    UserStatesView,
    EarningHistoryView,
    PayoutHistoryView,
    AffiliateUrlsList,
    NewReferralModal,
    LoaderComponent,
  },
  mounted() {
    if (this.userData.role != "Agency" || !this.userData.emailVerified) {
      this.$router.push("/dashboard");
    }
    this.syncTabFromRoute();
    this.referralLink = this.userData.referralLink;
    this.loadOverview().then(() => {
      this.getaffliateCommisionList();
    });
  },

  data() {
    return {
      dashboardDraft: true,
      loading: true,
      statsLoading: true,
      activeTab: "overview",
      filter: {
        s: "",
        e: "",
        order_date: "",
        columnTo: "id",
        orderBy: "desc",
        per_page: 5,
        page: 1,
        last_page: 1,
        length: "",
        date_form: "",
        date_to: "",
      },
      rows: [],
      prows: [],
      page: 1,
      per_page: 5,
      expanded: null,
      affiliateStatsData: [],
      draft_orders: [],
      earning_lists: [],
      url_lists: [],
      historyPayouts: [],
      referralLink: "",
      clientStatusChartData: [],
      all_clients: [],
      search: {
        client: "all",
      },
      loarder1: false,
      loarder2: false,
      loarder3: false,
      loarder4: false,
      premiumPlacementRequestButton: false,
      premiumPlacementRequestMessage: "",
      packages: [],
      errors: [],
      showPayoutBtn: false,
      newReferralOpen: false,
      earningCount: 0,
      activityLoaded: false,
      activityLoading: false,
    };
  },
  methods: {
    setTab(tab) {
      this.activeTab = tab;
      const query = { ...this.$route.query };
      if (tab === "overview") {
        delete query.tab;
      } else {
        query.tab = tab;
      }
      this.$router.replace({ path: this.$route.path, query }).catch(() => {});
      if (tab === "activity") {
        this.getaffliateCommisionList();
      }
    },
    syncTabFromRoute() {
      const tab = this.$route.query.tab;
      if (AFFILIATE_TABS.includes(tab)) {
        this.activeTab = tab;
      }
    },
    async loadOverview() {
      this.loading = true;
      this.statsLoading = true;
      try {
        const res = await this.$store.dispatch("AgencyUsers/getAffiliateOverviewDataAction");
        this.affiliateStatsData = res.stats || res;
        this.earning_lists = res.earning_lists || [];
        this.earningCount = Number(res.earning_count || this.earning_lists.length) || 0;
        this.showPayoutBtn = !!res.show_payout_btn;
        this.url_lists = res.url_lists || [];
        this.historyPayouts = res.history_payouts || [];
        this.activityLoaded = false;
      } catch (error) {
        this.errors = error.response?.data?.errors || [];
      } finally {
        this.loading = false;
        this.statsLoading = false;
      }
    },
    async affiliateStats() {
      try {
        this.affiliateStatsData = await this.$store.dispatch("AgencyUsers/getAffiliateStatsDataAction");
      } catch (error) {
        this.errors = error.response?.data?.errors || [];
      }
    },
    async getaffliateCommisionList() {
      if (this.activityLoaded || this.activityLoading) return;
      this.activityLoading = true;
      try {
        let res = await this.$store.dispatch("AgencyUsers/getAffiliateListDataAction");
        this.earning_lists = res.data || [];
        this.showPayoutBtn = res.show_payout_btn;
        this.earningCount = this.earning_lists.length;
        this.activityLoaded = true;
      } catch (error) {
        this.errors = error.response?.data?.errors || [];
      } finally {
        this.activityLoading = false;
      }
    },

    async affiliatePayoutHistory() {
      try {
        let res = await this.$store.dispatch("AgencyUsers/getAffiliateHistoryDataAction");
        this.historyPayouts = res.data || [];
      } catch (error) {
        this.errors = error.response?.data?.errors || [];
      }
    },

    async getAffiliateUrlList() {
      try {
        let res = await this.$store.dispatch("AgencyUsers/getAffiliateUrlListDataAction");
        this.url_lists = res.data || [];
      } catch (error) {
        this.errors = error.response?.data?.errors || [];
      }
    },

    async onReferralCreated(message) {
      this.newReferralOpen = false;
      toast.success(message, { timeout: 3000 });
      await this.getAffiliateUrlList();
    },
    async onReferralUpdated() {
      await this.getAffiliateUrlList();
    },
    closeWithdrawPanels() {
      this.$refs.overviewPayouts?.closeWithdraw?.();
      this.$refs.tabPayouts?.closeWithdraw?.();
    },
    async submitWithdraw({ method, amount }) {
      this.loading = true;
      try {
        const res = await this.$store.dispatch("AgencyUsers/requestPayoutDataAction", {
          method,
          amount,
        });
        if (res.success) {
          if (res.balance !== undefined) {
            this.$store.commit("Auth/userBalanceUpdateMutation", res.balance);
          }
          this.closeWithdrawPanels();
          this.activityLoaded = false;
          this.activityLoading = false;
          await this.loadOverview();
          this.getaffliateCommisionList();
          toast.success(res.message, { timeout: 3000 });
        } else if (res.message) {
          toast.error(res.message, { timeout: 3000 });
        }
      } catch (error) {
        const message = error.response?.data?.message || "Unable to process payout.";
        toast.error(message, { timeout: 3000 });
      } finally {
        this.loading = false;
      }
    },

    copyText() {
      const element = this.$refs.message;
      element.select();
      element.setSelectionRange(0, 99999);
      document.execCommand("copy");
      toast.success("URL copied", { timeout: 1500 });
    },
  },
  watch: {
    userData(newVal) {
      if (newVal.emailVerified) {
        this.userData.emailVerified = true;
      } else {
        this.userData.emailVerified = false;
      }
    },
    "$route.query.tab"(tab) {
      if (AFFILIATE_TABS.includes(tab)) {
        this.activeTab = tab;
      } else if (!tab) {
        this.activeTab = "overview";
      }
    },
  },
  computed: {
    activeLinksCount() {
      const active = this.url_lists.filter(
        (row) => String(row.status || "active").toLowerCase() !== "inactive"
      );
      return active.length || this.url_lists.length;
    },
    activityTabCount() {
      return this.activityLoaded ? this.earning_lists.length : this.earningCount;
    },
    userData() {
      const data = this.$store.getters["Auth/getUser"];
      return {
        name: data.name,
        email: data.email,
        balance: data.balance,
        role: data.role,
        profileImage: data.image,
        referralLink: data.referral_link,
        emailVerified: data.is_email_verified,
      };
    },
  },
};
</script>
